"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: 9px;\n  right: 14px;\n  opacity: 0.6;\n  cursor: pointer;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Styling
var IconLocation = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.isopen ? " > div { transform: rotate(180deg); position: relative; top: -6px; } " : '';
}); // Component


var SelectOptionsWrapper = function SelectOptionsWrapper(_ref) {
  var isOpen = _ref.isOpen;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(IconLocation, {
    isopen: isOpen,
    className: "icon-location-wrapper"
  }, _react["default"].createElement("div", {
    className: "icon-location-holder"
  }, _react["default"].createElement(_Icon["default"], {
    icon: "expand_more"
  }))));
};

SelectOptionsWrapper.propTypes = {
  isOpen: _propTypes["default"].bool
};
var _default = SelectOptionsWrapper;
exports["default"] = _default;